/**
 * Utility để xử lý URL media cho tin tức
 * Backend serve từ /api/public/ endpoint
 */

const stripDomain = (value: string) => value.replace(/^https?:\/\/[^/]+/i, '')

const splitPathAndQuery = (value: string) => {
  const [pathPart, ...queryParts] = value.split('?')
  return {
    path: pathPart,
    query: queryParts.length ? `?${queryParts.join('?')}` : ''
  }
}

export const buildNewsMediaUrl = (input?: string | null, fallback: string = ''): string => {
  if (!input) {
    return fallback
  }

  const trimmed = input.trim()

  // If already starts with /api/public/, return as is (relative path)
  if (trimmed.startsWith('/api/public/')) {
    return trimmed
  }

  // Check if it's a full URL
  const isFullUrl = /^https?:\/\//i.test(trimmed)
  
  // If it's a full URL and already has /api/public/, return as is
  if (isFullUrl && trimmed.includes('/api/public/')) {
    return trimmed
  }

  // Extract path from full URL or use as-is for relative paths
  const { path, query } = splitPathAndQuery(trimmed)
  let cleanPath = stripDomain(path).replace(/\\/g, '/')
  cleanPath = cleanPath.replace(/^\/+/, '')

  if (!cleanPath) {
    return fallback
  }

  // Remove 'api/' prefix if present
  if (cleanPath.startsWith('api/')) {
    cleanPath = cleanPath.replace(/^api\//, '')
  }

  // Handle different path formats from backend
  let imagePath = cleanPath

  // If path starts with public/, remove it and use the rest
  if (cleanPath.startsWith('public/')) {
    imagePath = cleanPath.slice('public/'.length)
  }

  // If path is just a filename, assume it's in images folder
  if (!imagePath.includes('/') && imagePath.includes('.')) {
    imagePath = `images/${imagePath}`
  }

  // Backend serves static files from /api/public/ endpoint
  const baseUrl =
    process.env.NEXT_PUBLIC_API_URL?.replace('/api', '') || 'http://localhost:7001'

  const normalizedBase = baseUrl.replace(/\/+$/, '')
  const normalizedPath = imagePath.replace(/^\/+/, '')

  // Return /api/public/images/... format
  return `${normalizedBase}/api/public/${normalizedPath}${query}`
}

